import * as React from "react";
import * as _ from "underscore";
import { connect } from "react-redux";
import { Button } from "carbon-components-react";
import { Save16 } from "@carbon/icons-react";

import { AppShape, HurdleShape, DocTypes } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import APIClient from "../../APIClient";
import DocDisplay from "../shared/DocDisplay";
import LabeledInput from "../../LabeledInput";
import { createHurdleOverride, deleteHurdleOverride } from "../actions";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

require(`../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
conflict_of_interest.scss`);

interface HurdleEditorProps extends HurdleProps {
  dispatch?: Function;
}

class ConflictOfInterestEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);

    const { hurdle } = props;

    // we don't save individual responses anywhere; if everything was resolved,
    // it means all checks should be marked true when reloading the page

    let checked;
    if (hurdle.status === "green") {
      checked = ConflictOfInterestEditor.checks.map(c => c.name);
    } else {
      checked = [];
    }

    this.state = { checked };
  }

  static docIsRelevantType(doc) {
    const relevantTypes = [
      DocTypes.PurchaseContract,
      DocTypes.TitleCommitment,
      DocTypes.SubjectPropertyReport,
      DocTypes.LoansafeAppraisalManagerReport,
    ];

    return _.contains(relevantTypes, doc.type);
  }

  static checks = [
    {
      name: "sellers_agent",
      label: "Seller's agent",
    },
    {
      name: "settlement_agent",
      label: "BYO settlement agent",
    },
    {
      name: "seller",
      label: "Seller",
    },
    {
      name: "names_in_title_report",
      label: "Names in title report",
    },
    {
      name: "names_in_chain_of_title",
      label: "Names anywhere in the chain of title for last 24 months",
    },
    {
      name: "to_add_to_title",
      label: "People or companies that borrower(s) seek to add to title",
    },
  ];

  onChange(e) {
    const { name, checked } = e.target;

    let update;
    if (checked) {
      update = _.union(this.state.checked, [name]);
    } else {
      update = _.without(this.state.checked, name);
    }

    this.setState({ checked: update });
  }

  createFlag(message) {
    const { app, hurdle } = this.props;

    APIClient.post("/flags", {
      message,
      application_id: app.id,
      hurdle_name: hurdle.name,
    }).then(() => {});
  }

  onSave() {
    const { hurdle, dispatch, app, onHide } = this.props;
    const { checked } = this.state;

    const allChecked = checked.length === ConflictOfInterestEditor.checks.length;

    if (!allChecked) {
      this.createFlag("Operator still needs to resolve potential conflict of interest items.");
    }

    if (!hurdle.override && allChecked) {
      createHurdleOverride(dispatch, {
        appId: app.id,
        hurdleName: hurdle.name,
        hurdleOverrideValues: {
          potential_conflicts_checked: true, // will resolve status to green server-side
        },
      });
    } else if (hurdle.override && !allChecked) {
      deleteHurdleOverride(dispatch, {
        appId: app.id,
        hurdleOverrideId: hurdle.override.id,
      });
    }

    onHide();
  }

  renderNoDocs() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <p>Waiting on PC ingestion, title, subject property report, and LSFM report</p>
      </HurdleView>
    );
  }

  renderSidebar() {
    return (
      <div className="conflict-of-interest__sidebar">
        <div className="conflict-of-interest__title">With regard to</div>
        <ul className="conflict-of-interest__list">
          <li>Last names</li>
          <li>Addresses</li>
          <li>Places of employment</li>
          <li>Bank account transactions</li>
        </ul>
        <div className="conflict-of-interest__title">Please check</div>
        {ConflictOfInterestEditor.checks.map(c => (
          <div key={c.name} className="conflict-of-interest__input">
            <LabeledInput
              inputType="boolean"
              inputName={c.name}
              inputValue={_.contains(this.state.checked, c.name) ? "true" : ""}
              labelValue={c.label}
              onChange={this.onChange.bind(this)}
            />
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { hurdle, app, onHide } = this.props;

    // can't find at least one copy of each of the four required doc types
    if (hurdle.status === "red") {
      return this.renderNoDocs();
    }

    const filteredDocs = _.filter(app.documents, d =>
      ConflictOfInterestEditor.docIsRelevantType(d),
    );

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <div className="conflict-of-interest__container">
          <div className="conflict-of-interest__pdf">
            <DocDisplay docs={filteredDocs} />
          </div>
          {this.renderSidebar()}
        </div>
        <footer className={styles.footer}>
          <Button kind="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button onClick={this.onSave.bind(this)} renderIcon={Save16}>
            Save changes
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

export default connect()(ConflictOfInterestEditor);
